/* eslint-disable react/no-multi-comp */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { NavigationListItem } from "./components";

const NavigationList = ({
  pages,
  depth = 0,
  isMenuCollapse,
  setActiveKey,
  activeKey,
  onSelect,
  openMenuId,        
  setOpenMenuId,      
}) => {
  const location = useLocation();

  return (
    <>
      {pages.map((page) => {
        const hasChildren =
          Array.isArray(page.children) && page.children.length > 0;

          // Helper to check if the current path belongs to this menu or any of its children
          const isPathActive = (menuPath, currentPath) => {
            if (!menuPath) return false;
            const normalizedMenuPath = `/${menuPath.replace(/^\//, "")}`;
            const pattern = new RegExp(`^${normalizedMenuPath}(?:/|$)`, "i");
            return pattern.test(currentPath);
          };

          // Recursive check for any active child route
          const checkActiveChild = (children = []) => {
            return children.some((child) => {
              if (isPathActive(child.href, location.pathname)) return true;
              if (child.children && child.children.length > 0) {
                return checkActiveChild(child.children);
              }
              return false;
            });
          };

          const hasActiveChild = hasChildren && checkActiveChild(page.children);

        return (
          <NavigationListItem
            key={page.id || page.title}
            title={page.title}
            href={page.href}
            depth={depth}
            pageid={page.id}
            menuIcon={page.menu_icon}
            isMenuCollapse={isMenuCollapse}
            setActiveKey={setActiveKey}
            open={location.pathname.includes(page.href)}
            activeKey={activeKey}
            onSelect={onSelect}
            hasActiveChild={hasActiveChild}
            hasChildren={hasChildren}
            openMenuId={openMenuId}          
            setOpenMenuId={setOpenMenuId}    
          >
            {hasChildren && (
              <NavigationList
                pages={page.children}
                depth={depth + 1}
                isMenuCollapse={isMenuCollapse}
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                onSelect={onSelect}
                openMenuId={openMenuId}       
                setOpenMenuId={setOpenMenuId} 
              />
            )}
          </NavigationListItem>
        );
      })}
    </>
  );
};

NavigationList.propTypes = {
  pages: PropTypes.array.isRequired,
  depth: PropTypes.number,
  isMenuCollapse: PropTypes.bool,
  setActiveKey: PropTypes.func,
  activeKey: PropTypes.array,
  onSelect: PropTypes.func,
  openMenuId: PropTypes.string,       
  setOpenMenuId: PropTypes.func,      
};

const Navigation = (props) => {
  const {
    pages,
    component: Component,
    isMenuCollapse,
    setActiveKey,
    activeKey,
    onSelect,
    openMenuId,       
    setOpenMenuId,    
    ...rest
  } = props;

  return (
    <Component {...rest}>
      <NavigationList
        pages={pages}
        depth={0}
        isMenuCollapse={isMenuCollapse}
        setActiveKey={setActiveKey}
        activeKey={activeKey}
        onSelect={onSelect}
        openMenuId={openMenuId}        
        setOpenMenuId={setOpenMenuId}  
      />
    </Component>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string,
  activeKey: PropTypes.array,
  onSelect: PropTypes.func,
  openMenuId: PropTypes.string,       
  setOpenMenuId: PropTypes.func,      
};

Navigation.defaultProps = {
  component: "div",
};

export default Navigation;
